import { Theme } from "../../constants";

export default {
    container: {
        display: "flex",
        flexDirection: "column",
        padding: "10px 10px 10px 15px",
        boxShadow: "0px 10px 10px rgba(38, 38, 38, 0.05)",
        borderRadius: "8px",
        cursor: "pointer",
        gap: "5px",
    },
    labelContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "15px"
    },
    greenBorder: {
        border: `2px solid ${Theme.GREEN_BORDER_COLOR}`,
    },
    boxNumberContainer: {
        display: "flex",
        flexDirection: "row",
    },
    boxNumberTitleNumber: {
        display: "flex",
        alignItems: "center",
        gap: "5px",
        fontWeight: 700,
        fontSize: "20px",
    },
    boxNumberStyle: {
        lineHeight: "31px",
    },
    blurredBox: {
        opacity: 0.2,
    }
}